module.exports = __webpack_public_path__ + "img/inflatablePink.9ece7a72.svg";